export type InstructorFormValues = {
  id: number | null;
  name: string;
  email: string;
  phone: string;
  password: string;
  passwordConfirmation: string;
  image: string;
  imagePreview: string;
  bio: string;
  isActive: boolean;
  stageIds: number[];
  gradeIds: number[];
  subjectIds: number[];
};

export type GradeRow = { id: number; name: string; stage_id: number };
export type StageRow = { id: number; name: string; slug?: string };

export type SubjectRow = {
  id: number;
  name: string;
  stage_id?: number | null;
  stage_ids?: number[];
};

export type InstructorFormOptions = {
  stages: StageRow[];
  grades: GradeRow[];
  subjects: SubjectRow[];
};

export const emptyInstructorForm = (): InstructorFormValues => ({
  id: null,
  name: "",
  email: "",
  phone: "",
  password: "",
  passwordConfirmation: "",
  image: "",
  imagePreview: "",
  bio: "",
  isActive: true,
  stageIds: [],
  gradeIds: [],
  subjectIds: [],
});
